<style lang="scss" scope>
.mr1 {
  min-width: 20px;
  margin-right: 1rem;
}
.flexs {
  display: flex !important;
  width: 20%;
}
//  需要改某一个 样式    equipment 下面的 子 el-form-item__label
.equipment .el-form-item__label {
  line-height: 22px;
}
.l-table-place {
  height: auto;
  max-height: 200px;
}
</style>

<template>
  <el-card shadow="never" class="l-main-card"
     v-loading="loading_export"
    element-loading-text="拼命导出中"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)">
    <div class="l-table-place">
      <div class="flex flex-warp">
        <div class="flexs items-center ivu-mt ivu-mr">
          <p class="mr1">场所名称</p>
          <el-input placeholder="请输入场所名称" v-model="search_data.name" class="input-with-select" style="width: 76%;">
            <el-button slot="append" icon="el-icon-search" @click="onSearch"></el-button>
          </el-input>
        </div>
        <div class="flexs items-center ivu-mt ivu-mr">
          <p class="mr1">所属社区</p>
          <div class="l-show-more-search">
            <el-select v-model="search_data.community_id" placeholder="全部" clearable @change="changes">
              <el-option v-for="item in community_list" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </div>
        </div>

        <div class="flexs items-center ivu-mt ivu-mr">
          <p class="mr1">场所状态</p>
          <div class="l-show-more-search">
            <el-select v-model="search_data.state" placeholder="全部" clearable  @change="changes">
              <el-option 
                v-for="(item, index) in MANAGEMENT"
                :key="index"
                :label="item"
                :value="index"
              ></el-option>
            </el-select>
          </div>
        </div>
      
    
        <!-- <div class="flexs items-center ivu-mt ivu-mr">
          <l-auth-button class="" type="info" auth="rental_file_export_btn" @click="file_export" :loading="export_loading"> 导出 </l-auth-button>
        </div> -->
      </div>
      <div class="items-center ivu-mt">
        <l-auth-button type="primary" auth="archives_export_btn" icon="el-icon-download" @click="handleExport">
          导出
        </l-auth-button>
      </div>
    </div>
    <div class="l-primary l-table-config" style=" border-bottom: solid 1px #e4e7ed;">
      <el-popover placement="bottom-start" width="200" trigger="click" popper-class="l-table-column-fixed-select-box">
        <span slot="reference">
          <i class="el-icon-setting"></i>表格列表配置
        </span>
        <div class="">
          <div class="l-flex l-flex-just-between" style="margin-bottom:10px">
            <div>
              表格列表配置
              <i class="el-icon-refresh-left" style="float:right;  color: red;margin: 3px;" @click="resetFixedCheck">重置</i>
            </div>
          </div>
          <el-divider class="l-table-column-fixed-title-divider"></el-divider>
          <el-checkbox-group v-model="fixed_list">
            <div v-for="(item,index) in columns" :key="index">
              <el-checkbox :label="item.prop" style="margin-bottom:4px">
                {{item.label}}
              </el-checkbox>
            </div>
          </el-checkbox-group>
        </div>
      </el-popover>

    </div>
    <l-table :data="data" v-loading="loading" row-key="id" @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="55">
      </el-table-column>
      <el-table-column v-for="(item, index) in columns" :key="index" v-bind="{ ...item }" :label="item.label" show-overflow-tooltip>
        <template v-slot="{ row }">
          <template v-if="item.prop == 'name'">
            <slot><a>{{row.name}}</a></slot>
          </template>

          <template v-else>
            {{ row[item.prop] }}
          </template>
        </template>
      </el-table-column>
      <!-- <el-table-column fixed="right" label="操作" width="120" align="center">
        <template slot-scope="{ row }">
          <l-auth-text-button type="primary" auth="place_info_btn" @click="showInfo(row.id)"><i class="el-icon-edit"></i>下载</l-auth-text-button>
        </template>
      </el-table-column> -->

    </l-table>

    <!--分页-->
    <l-page :total="count" @current-change="getList" @size-change="getList" :page-size.sync="page_size" :current-page.sync="page"></l-page>

    <!--场所详情-->
    <l-dialog :visible.sync="place_info_visible" title="场所信息" width="1600px">
      <l-place-info :visible.sync="place_info_visible" :id="place_id" is-info />
    </l-dialog>

  </el-card>
</template>
<script>


// import { dateToStr,time_pick2 } from "@/utils/Fuc";
import PlaceInfo from "../place/Info.vue";
import Vue from "vue";
export default {
  components: {
    [PlaceInfo.name]: PlaceInfo,
  },
  data() {
    return {
      value1: '',
      data: [],
      count: 0,
      page: 1,
      page_size: Vue.$_config.page.page_size,
      loading: false,
        loading_export:false,
      change_state_loading: [],
      place_type_list: [],
      community_list: [],
      MANAGEMENT:[],
      place_id:0,
      place_info_visible: false,
      //搜索
      search_visible: false,
      search_data: {
        name: '',
        community_id: '',
        state: '',
        place_type: 3,
      },
      rel_search_data: {},
      show_more_search: false,
      value2: '',
      //默认
      re_fixed_list: ["index"],
      fixed_list: ["index"],
      multipleSelection: [],//选择
    };
  },
  computed: {
    columns() {
      let columns = [
        {
          prop: "index",
          label: "序号",
          fixed: true,
          width: "60",
        },
        {
          prop: "place_id",
          label: "场所ID",
          fixed: true,
          width: "70",
        },
        {
          prop: "street_name",
          label: "所属街道",
          fixed: true,
          Width: "100",
        },
        {
          prop: "community_name",
          label: "所属社区",
          fixed: true,
          Width: "100",
        },

        {
          prop: "place_sn",
          label: "场所编码",
          fixed: true,
          Width: "120",
        },
        {
          prop: "name",
          label: "场所名称",
          fixed: true,
          Width: "120",
        },
        {
          prop: "address",
          label: "场所地址",
          fixed: false,
          width: "120",
        },
        {
          prop: "export_count",
          label: "可导出次数",
          fixed: false,
          width: "80",
        },
        {
          prop: "building_ext_photo",
          label: "外景照片",
          fixed: false,
          width: "100",
        },
        {
          prop: "train_photo",
          label: "培训照片",
          fixed: false,
          width: "100",
        },
        {
          prop: "train_sign_photo",
          label: "培训签到照片",
          fixed: false,
          width: "100",
        },
        {
          prop: "commitment_photo",
          label: "承诺书照片",
          fixed: false,
          width: "100",
        },
        {
          prop: "fire_extinguisher_photo",
          label: "灭火器照片",
          fixed: false,
          width: "100",
        },
        {
          prop: "emergency_photo",
          label: "应急灯照片",
          fixed: false,
          width: "100",
        },
        {
          prop: "indicator_light_photo",
          label: "疏散指示标志照片",
          fixed: false,
          width: "100",
        },
        {
          prop: "hose_reel_photo",
          label: "消防软管卷盘照片",
          fixed: false,
          width: "100",
        },
      ];

      let result = columns.map((item) => {
        const index = this.fixed_list.findIndex((itm) => {
          return itm == item.prop;
        });
        if (index != -1) {
          item.fixed = true;
          if (!item.width) {
            item.width = item.minWidth;
          }
        } else {
          if (item.minWidth && item.width) {
            delete item.width;
          }
          item.fixed = false;
        }

        return item;
      });

      return result;
    },
  },

  watch: {

    fixed_list(val) {
      if (val.length > 20) {
        this.fixed_list.shift();
      }
    },
  },

  mounted() {
    this.getList();
    this.getSearchData();
  },

  methods: {
    
    changes() {
      this.rel_search_data = this.search_data;
      this.getList();
    },
    //打开场所详情
    placeInfo(id) {
      this.place_id = id;
      this.$nextTick(() => {
        this.place_info_visible = true;
      });
    },
    //获取数据
    getList() {
      this.loading = true;
       this.rel_search_data = this.search_data;
      this.$_invoke("archives_getList", {
        page: this.page,
        page_size: this.page_size,
        ...this.rel_search_data,
      })
        .then((ret) => {
          this.data = ret.data;
          this.count = ret.count;
        })
        .finally(() => {
          this.loading = false;
        });
    },

    //获取搜索信息
    getSearchData() {
      this.loading = true;
      this.$_invoke("place_getSearchData", {
        type: this.search_data.place_type
      })
        .then((ret) => {
          this.street_list = ret.street_list;
          this.community_list = ret.community_list;
          this.MANAGEMENT = ret.place_state_list;
        })
        .finally(() => {
          this.loading = false;
        });
    },

    //点击搜索按钮
    onSearch() {
      this.page = 1;
      this.rel_search_data = this.search_data;
      this.getList();
    },

    //点击重置搜索框
    onReset() {
      this.$refs.search_form.resetFields();
      this.rel_search_data = {};
    },

    //页码改变
    pageChange(page) {
      this.page = page;
      this.getList();
    },

    //每页显示条数改变
    pageSizeChange(page_size) {
      this.page_size = page_size;
      this.getList();
    },
    //显示详情
    showInfo(id) {
      this.info_id = id;
      this.$nextTick(() => {
        this.info_visible = true;
      });
    },
    //重置固定栏位选择
    resetFixedCheck() {
      this.fixed_list = JSON.parse(JSON.stringify(this.re_fixed_list));
    },

    //选择
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    //导出
    handleExport() {
      if(this.multipleSelection.length==0){
        this.$message.error('请先选择要导出的场所');
        return;
      }
      const select_place_id=this.multipleSelection.map((v)=>v["id"]);
      this.loading_export = true;
      this.$_invoke('archives_export', { ...this.search_data,place_id:select_place_id })
        .then((ret) => {
          window.open(ret);
        })
        .finally(() => {
          this.loading_export = false;
        });
    },
  },
};
</script>

<style lang="scss">
.l-table-config {
  margin-bottom: 20px;
}
.l-table-toolbar {
  width: 100%;
}
.input-with-select {
  margin-bottom: 10px;
}
.l-simple-search-container {
  float: none;
}
</style>
